// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/term.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/term.proto.
 */
export const file_studyo_today_schedules_v1_resources_term = /*@__PURE__*/
  fileDesc("Ci5zdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy90ZXJtLnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyKTAQoEVGVybRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEiQKCXN0YXJ0X2RheRgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSIgoHZW5kX2RheRgEIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSEAoIcmV2aXNpb24YBSABKAUSFQoNc2hvdWxkX2RlbGV0ZRgGIAEoCEIrqgIoU3R1ZHlvLlRvZGF5LlNjaGVkdWxlcy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_type_date]);

/**
 * Describes the message studyo.today.schedules.v1.resources.Term.
 * Use `create(TermSchema)` to create a new message.
 */
export const TermSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_term, 0);

